import React, {useEffect, useImperativeHandle} from "react";
import {Button, Form, Input} from "antd";
import {getModelState, useModel} from "../../../models";

export default function ({sRef}) {
    const [form] = Form.useForm();

    const [{searchParam, selectedTypeNode}, {setSearchParam, loadCustomerList}] = useModel("customer");

    useEffect(() => {
        // console.log(searchParam)
        form.setFieldsValue(searchParam);
    }, []);

    useImperativeHandle(sRef, () => ({
        getSearchForm: () => form
    }))

    const onFinish = () => {
        const params = form.getFieldValue();
        // console.log(selectedTypeNode)
        if (selectedTypeNode) {
            params.customerType = selectedTypeNode.key;
        }else{
            params.customerType = null;
        }
        // console.log(params)
        setSearchParam(params)
        loadCustomerList({data:params});
    }

    const onReset = () => {
        form.resetFields();
        setSearchParam({})
        loadCustomerList({data:{}});
    }

    return (
        <Form
            form={form}
            name="customer_search"
            layout="inline"
            onFinish={onFinish}
            // onValuesChange={e => setSearchParam(e)}
        >
            <Form.Item
                name="customerCode"
                label="客户编码"
            >
                <Input placeholder="客户编码"/>
            </Form.Item>
            <Form.Item
                name="customerName"
                label="客户名称"
            >
                <Input placeholder="客户名称"/>
            </Form.Item>
            <Form.Item
                name="customerCorporation"
                label="联系人"
            >
                <Input placeholder="联系人"/>
            </Form.Item>
            <Form.Item
                name="customerCorporationPhone"
                label="联系电话"
            >
                <Input placeholder="联系电话"/>
            </Form.Item>
            <Form.Item shouldUpdate={true}>
                {() => (
                    <>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            查询
                        </Button>
                        <Button
                            htmlType="submit"
                            className="margin-left-8"
                            onClick={onReset}
                        >
                            重置
                        </Button>
                    </>
                )}
            </Form.Item>
        </Form>
    );
}